<template>
  <Modal position="end" ref="modalRef">
    <template #header>Pet Policy</template>
    <template #body>
      <PropertyPetPolicyForm ref="formRef" />
    </template>
    <template #footer>
      <Button variant="ghost" @click="modalRef?.close">Cancel</Button>
      <Button @click="save">Save</Button>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { ref } from 'vue';

import { Modal, Button } from '@tallo/design-system';
import { PropertyPetPolicyForm } from '@tallo/investor/property';

const modalRef = ref<InstanceType<typeof Modal>>();
const formRef = ref<InstanceType<typeof PropertyPetPolicyForm>>();

async function save() {
  await formRef.value?.save();

  modalRef.value?.close();
}

defineExpose({ modalRef });
</script>
